import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { ConstantData } from 'src/app/services/constants';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  partnerCustomers: any = [];
  searchData: any;
  timeOutSearch: any;
  testimonialsTimer: any;
  testimonialsPage: number = 0;
  get customers() {
    return this.util.customerTestimonials?.map((data: any) => {
      const messages = data.message.split('\\n');
      const name = data.name?.split(' ') || [];
      return {
        "image": data.image_64 ? this.util.getImageFromBase64(data.image_64) : null,
        "name": data.name,
        'nameInitials': name.shift()?.charAt(0) + name.pop()?.charAt(0),
        "designation":data.role,
        "description": messages[0],
      }
    });
  }
  get activeProcessItem() {
    return this.processItems.find((item) => item.isSelected);
  }
  isActivateProcessClick: boolean = false;
  get isLastProcessItem(): boolean {
    if (this.isActivateProcessClick) {
      return true;
    }
    const lastIndex = this.processItems.length - 1;
    if (this.processItems[lastIndex].isSelected) {
      this.isActivateProcessClick = true;
      return true;
    }
    return false;
  }

  processItems = [
    {
      title: '100% Digital KYC',
      isSelected: true,
      img: 'assets/images/home/process_slide_1.png',

    },
    {

      title: 'Simple Underwriting',
      isSelected: false,
      img: 'assets/images/home/simple_underwriting.png'

    },
    {

      title: 'Quick Approval',
      isSelected: false,
      img: 'assets/images/home/process_slide_2.png'

    },
    {

      title: 'Flexible Repayment',
      isSelected: false,
      img: 'assets/images/home/process_slide_4.png'
    },

  ];
  timeIntermval: any;
  customerApplied: number = 0;
  totalDisbursedCount: number = 0;
  totalAmountDisbursed: any = 0;
  totalAmountDisbursedUnit:string = 'cr';
  yearsOfImpact: any = 0;
  livesImpacted: any = 0;
  playStoreLink: string = ConstantData.playStoreLink;
  ourProcessintervale: any;
  activeCarouselItem: number = 0;
  get prevItemIndex(): number {
    const index = this.activeCarouselItem - 1;
    return index < 0 ? (this.customers.length - 1) : index;
  }
  get lastItemIndex(): number {
    const index = this.activeCarouselItem + 1;
    return index > (this.customers.length - 1) ? 0 : index;
  }
  constructor(public util: UtilService) {

  }

  ngOnInit(): void {
 
    

    this.initData();
    this.loanTestimonials();
  }

  initData(){
    this.totalAmountDisbursed = 0;
    this.totalDisbursedCount = 0;
    this.livesImpacted = 0;
    this.yearsOfImpact = 0;
    this.customerApplied = 0;
    this.util.setCache('ishome', true);
    
  
    this.util.loaderService.show();
    setTimeout(() => {
      this.counterAnimation();
      this.ourProcessAnimation();
      this.util.loaderService.hide();
    }, 2000);
    this.util.userLoggedInEventCalled.subscribe((res: boolean) => {
      if (res) {
        setTimeout(() => { 
          const course: any = sessionStorage.getItem('course');
          if (course)
           {
            this.util.openCourses(JSON.parse(course));}
          // sessionStorage.removeItem('course');
        }, 1000);
      } 
    })
  }
  openDrop(id: string) {
    $('#' + id).toggleClass('open').parent('.cus-dropdown').toggleClass('opened');
  }
  playstoreApp() {
    window.open(this.playStoreLink);
  }
  ourProcessAnimation() {
    clearInterval(this.ourProcessintervale);
    this.ourProcessintervale = setInterval(() => {
      const lastIndex = this.processItems.length - 1;
      const activeIndex = this.processItems.findIndex((item) => item.isSelected);
      this.processItems[activeIndex].isSelected = false;
      this.processItems[(activeIndex + 1) > lastIndex ? 0 : (activeIndex + 1)].isSelected = true;
      this.processItems = [...this.processItems];
      // }
    }, ConstantData.ourProcessAnimationTime)
  }

  counterAnimation() {
    
   clearInterval(this.timeIntermval);
    setTimeout(() => {
      this.timeIntermval = setInterval(() => {
        if(!this.util.stats)
        return;
        const customerApplied = this.util.stats.customerApplied; 
        const disbursedCount = this.util.stats.disbursedCount; 
        const disbursedData = this.util.formatNumber(this.util.stats.amountDisbursed || '0').split(' ');
        const amountDisbursed = +(disbursedData[0]);
        this.totalAmountDisbursedUnit = disbursedData[1];
        if (this.customerApplied < customerApplied)
          this.customerApplied += customerApplied > 1000 ? Math.round((Math.random() * 100)) : Math.round((Math.random() * 10));
        else {
          this.customerApplied = customerApplied;
        }

        if (this.totalDisbursedCount < disbursedCount)
          this.totalDisbursedCount += disbursedCount > 1000 ? Math.round((Math.random() * 100)) : Math.round((Math.random() * 10));
        else{
          this.totalDisbursedCount = disbursedCount;
        }

        if (this.totalAmountDisbursed < amountDisbursed) {
          this.totalAmountDisbursed = (+this.totalAmountDisbursed) + 1;
          this.totalAmountDisbursed = (this.totalAmountDisbursed);
        }else{
          this.totalAmountDisbursed = amountDisbursed;
        }




        if (this.timeIntermval && this.customerApplied === customerApplied) {
          this.customerApplied = customerApplied
          this.totalAmountDisbursed = (amountDisbursed);
          this.totalDisbursedCount = disbursedCount;
          clearInterval(this.timeIntermval);
        }

      }, 1);
    }, 1000);
  }

  activateProcess(i: number) {
    const activeIndex = this.processItems.findIndex((item) => item.isSelected);
    this.processItems[activeIndex].isSelected = false;
    this.processItems[i].isSelected = true;
    this.ourProcessAnimation()
  }

  loanTestimonials() {

    this.util.handleRequests('get', this.util.getUrl('courses_testimonials'), undefined, undefined, undefined, undefined, false).then((res: any) => {
      if (res) {
        this.changePage({page:-1});
        this.partnerCustomers = res.map((data: any) => {
          const messages = data.message.split('\\n');
          return {
            "image": this.util.getImageFromBase64(data.image64),
            "name": messages[1].replaceAll('-', ''),
            "designation": data.name,
            "description": messages[0],
          }
        });
      }

    })
  }

  searchCourse(ev: any) {
    const query = ev.target.value || '';
    if (this.timeOutSearch)
      clearTimeout(this.timeOutSearch);
    if (!query) {
      this.searchData = null;
      return;
    }


    this.timeOutSearch = setTimeout(() => {
      this.util.searchAllCoursesInstitudes(query, 0, 10, false).then((res: any) => {
        this.searchData = res;
      });
    }, 500);

  }

  selectCourse(course: any) {
    this.util.selectCourse(course);
  }
  changePage(ev: any) {
    this.activeCarouselItem = ev.page;
    this.testimonialsPage = ev.page;
    if (this.testimonialsTimer) {
      clearTimeout(this.testimonialsTimer);
    }
    this.testimonialsTimer = setTimeout(() => {
      this.activeCarouselItem = ((this.customers?.length || 1) - 1) > this.activeCarouselItem ? this.activeCarouselItem + 1 : 0;
      this.testimonialsPage = this.activeCarouselItem;
    }, 4000)
  }
  ngOnDestroy(): void {
    this.util.setCache('ishome', false);
  }
}
